import { apiFetchJson } from '@/lib/api-fetch'

export interface AppUserProgressRow {
  module_id: string
  lesson_id: string | null
  quiz_score: number | null
  quiz_passed: boolean | null
  completed_at: string | null
  created_at: string | null
}

export async function fetchAppUserProgress(): Promise<AppUserProgressRow[]> {
  return apiFetchJson<AppUserProgressRow[]>('/api/app/v1/user-progress')
}
